export default "__VITE_ASSET__MB6IHHVx__"